import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { Container, Sprite, Text } from '@pixi/react';

import { notificationStore } from '../../../store/notificationStore';

import { isMobile } from '../../../core/helpers/isMobile';
import { getGameImages } from '../../../core/helpers/getGameImages';

const Maintenance = observer(() => {
  const { maintenanceText } = notificationStore;
  const { maintenanceBackground, maintenanceIcon } = useMemo(() => {
    return getGameImages();
  }, []);

  return (
    <Container x={isMobile() ? 30 : 857} y={isMobile() ? 52 : 70}>
      <Sprite
        y={24}
        alpha={0.8}
        anchor={0.5}
        x={isMobile ? 250 : 281}
        texture={maintenanceBackground}
      />
      <Sprite texture={maintenanceIcon} anchor={0.5} x={isMobile ? 19 : 21} y={24} />
      <Text
        text={maintenanceText}
        x={46}
        y={20}
        anchor={{ y: 0.5 }}
        style={{
          _fontSize: 14,
          _wordWrap: true,
          _fontWeight: 500,
          _fill: '#FFFFFF',
          _wordWrapWidth: 440,
          _fontFamily: 'poppinsMedium',
        }}
      />
    </Container>
  );
});
export default Maintenance;
